<div class="cont" *ngIf="article?.html">
  <h1>{{article?.titre}}</h1>
  <div class="dyn" [innerHtml]="article?.html | unsafe:'html'"> </div>
  <div class="clearfix"></div>
  <div class="auteur"> Par {{article?.auteur}} le {{article?.creation | date:"medium"}}</div>
  <div class="action"><button mat-button [routerLink]="['/','articles']">Retourner à la liste des Articles</button>
  </div>
</div>